import { Bell, Menu, Search } from "lucide-react";
import { useAdminAuth } from "@/admin/auth/AdminAuthContext";

export function Topbar({ onMenuClick }) {
  const { session } = useAdminAuth();

  return (
    <header className="flex flex-col gap-4 rounded-[28px] border border-white/70 bg-white/80 px-5 py-4 shadow-[0_18px_60px_rgba(13,55,148,0.1)] backdrop-blur-sm sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onMenuClick}
          className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-[#dce6fb] bg-[#f7faff] text-[#12338d] lg:hidden"
          aria-label="Open navigation"
        >
          <Menu className="h-5 w-5" />
        </button>
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-[#5f79c4]">
            QuickDropGo Admin
          </p>
          <h1 className="mt-1 font-display text-2xl font-extrabold tracking-tight text-[#0b1221]">
            Operations dashboard
          </h1>
        </div>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <div className="flex items-center gap-3 rounded-2xl border border-[#dce6fb] bg-[#f8fbff] px-4 py-3 text-[#6c7c98]">
          <Search className="h-4 w-4" />
          <span className="text-sm">Search orders, riders, or partners</span>
        </div>
        <button
          type="button"
          className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-[#dce6fb] bg-white text-[#12338d]"
          aria-label="Notifications"
        >
          <Bell className="h-5 w-5" />
        </button>
        <div className="rounded-2xl border border-[#dce6fb] bg-white px-4 py-3 text-right">
          <p className="text-sm font-semibold text-[#0b1221]">{session?.name}</p>
          <p className="text-xs text-[#6c7c98]">{session?.email}</p>
        </div>
      </div>
    </header>
  );
}